import React, { useEffect, useState, useRef } from 'react'
import SVG from 'react-inlinesvg'
import arrow from '../../../../_metronic/images/arr072.svg'
import { GET_SALES_CHANNEL_LIST_BY_USER } from '../../../../utils/GraphQLAPI'
import { useLazyQuery } from '@apollo/client'
import _ from 'lodash'

export default function SalesChannelFilter({ colors, setFilterOptions, setRecordingFilter }: any) {
  const [options, setOptions] = useState<any>([])
  const [searchOptions, setSearchOption] = useState<any>("")
  const [selectedOptions, setSelectedOption] = useState<any>([])
  const inputRef = useRef<any>();

  useEffect(() => {
    // initialize debounce function to search once user has stopped typing every half second
    inputRef.current = _.debounce(search, 500);
  }, []);

  useEffect(() => {
    localStorage.removeItem("agentFilter");
    getSalesChannelListByUser()
  }, [])

  // Filter Query
  const [getSalesChannelListByUser] = useLazyQuery(GET_SALES_CHANNEL_LIST_BY_USER, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setOptions(
        data?.getSalesChannelListByUser.salesChannels.map((x: any) => ({
          checked: false,
          ...x,
        }))
      )
    },
  })

  // Search the dropdown value
  const search = (event: any) => {
    setSearchOption(event.target.value)
  }

  // Clear all the selected Checkbox
  const clearAllCheckbox = async () => {
    setSelectedOption([])
    setSearchOption('')
    getSalesChannelListByUser()
    setRecordingFilter((prev: any) => ({ ...prev, salesChannelIds: null }))
    setFilterOptions((prev: any) => ({ ...prev, saleChannelsIds: null }))
  }

  // Function to select and unselect the checkboxes
  const onSelect = async (e: any, data: any) => {
    if (e.target.checked) {
      setSelectedOption([...selectedOptions, data.id])
      setOptions(() => {
        return options.map((item: any) => {
          if (item.id === data.id) {
            return { ...item, checked: true }
          }
          return item
        })
      })
    } else {
      const dataPresent: any = selectedOptions?.indexOf(data.id)
      selectedOptions.splice(dataPresent, 1)
      setOptions(() => {
        return options.map((item: any) => {
          if (item.id === data.id) {
            return { ...item, checked: false }
          }
          return item
        })
      })
    }
  }

  // Applying Filters to query the data
  const applyFilters = () => {
    setSearchOption('')
    if (selectedOptions.length === 0) {
      setFilterOptions((prev: any) => ({ ...prev, saleChannelsIds: null }))
      setRecordingFilter((prev: any) => ({ ...prev, salesChannelIds: null }))
    } else {
      setFilterOptions((prev: any) => ({ ...prev, saleChannelsIds: selectedOptions }))
      setRecordingFilter((prev: any) => ({ ...prev, salesChannelIds: selectedOptions }))
    }
  }

  return (
    <>
      <div className='h-38px border-0 rounded'>
        <a
        className='btn btn-sm d-flex align-items-center justify-content-between w-170px'
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'
          style={{
            background: '#ffff',
            height: '43px',
            width: '218px',
            paddingLeft: '30px',
            color: '#7E8299',
            borderRadius: '6px',
          }}
        >
          {selectedOptions.length === 0 ? "All Sales Channel" : `${selectedOptions.length} Selected`}
          <span className={`svg-icon svg-icon-2`}>
            <SVG src={arrow} width='21px' height='21px' />
          </span>
        </a>

        {/* begin::Menu */}
        <div
          className=' menu menu-sub menu-sub-dropdown'
          style={{ width: '220px' }}
          data-kt-menu='true'
        >
          <div className='mx-1 my-1 menu-item' data-kt-sticky-top='auto'>
            <input
              type='text'
              className='form-control form-control-solid'
              style={{ width: '210px' }}
              placeholder='Search'
              value={searchOptions}
              onChange={(e) => {
                search(e)
              }}
            />
          </div>
          <div
            className='menu-column menu-gray-600 overlay-y menu-state-bg-primary fs-7 py-4 w-160px'
            style={{
              width: '215px',
              maxHeight: '304px',
              overflowY: 'scroll',
              borderRadius: '6px',
            }}
          >
            {options.filter((item: any) => item.name.toLowerCase().includes(searchOptions?.toLowerCase())).map((optionData: any, index: any) => {
              return (
                <div
                  className='menu-item w-160px'
                  style={{ width: '200px ', padding: '12px 16px' }}
                  key={optionData.id}
                >
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      type='checkbox'
                      className='form-check-input'
                      checked={optionData?.checked}
                      value={optionData.name}
                      onClick={(e) => {
                        onSelect(e, optionData)
                      }}
                    />
                    <label
                      htmlFor=''
                      style={{ color: '#5E6278' }}
                      className='form-check-label fw-semibold fs-5'
                    >
                      {optionData?.name}
                    </label>
                  </div>
                </div>
              )
            })}
          </div>
          <div className='menu-item my-1'>
            <button
              style={{ 
                width: '85px',
                height: '36px',
                fontSize: '13px',
                marginBottom: '10px',
                marginRight: '10px'
              }}
              className='btn btn-secondary w-59px h-36px mx-4 p-0'
              onClick={clearAllCheckbox}
            >
              Clear
            </button>
            <button
              style={{
                width: '85px',
                height: '36px',
                fontSize: '13px',
                marginBottom: '10px',
                marginRight: '10px'
              }}
              className='btn btn-primary w-59px h-36px mx-2 me-3 p-0'
              onClick={applyFilters}
              data-kt-menu-dismiss='true'
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
